const AUTH = ["게스트", "공백", "일반", "사용자관리자", "시스템관리자"]

export default AUTH;